import React from "react";
import "../styles/CustomerSupport.css";
import { Link } from "react-router-dom";
import raiseTicket from "../images/customer_support/raise_ticket.svg";
import arrowTicket from "../images/customer_support/arrow_right.svg";
import email from "../images/customer_support/email.svg";
import contacts from "../images/customer_support/contacts.svg";
import customerSupport from "../images/customer_support/customer_support.svg";
import { Helmet } from 'react-helmet-async'; // Import Helmet

// Functional component for the Home page
const PrivacyPolicy = () => {
  return (
    <>
    {/* Helmet for SEO Metadata */}
<>
  {/* Helmet for SEO Metadata */}
  <Helmet>
    <title>Privacy Policy | Fundswala</title>
    <meta
      name="description"
      content="Read the Privacy Policy of Fundswala to understand how we collect, use, and protect your personal information."
    />
  </Helmet>

  <div className="container-fluid page_background">
    <div className="page-inner-content mb-4">
      <div className="page_inner_content_box">
        <h1 className="mb-4 main-heading-title text-center" style={{ fontSize: "40px" }}>
          Privacy Policy
        </h1>

        <div className="container mt-5">
          <p>Last updated: October 14, 2025</p>
          <p>
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
          </p>
          <p>
            We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the{" "}
            <a href="https://www.termsfeed.com/privacy-policy-generator/" target="_blank" rel="noopener noreferrer">
              Privacy Policy Generator
            </a>.
          </p>

          <h2>Interpretation and Definitions</h2>
          <h3>Interpretation</h3>
          <p>
            The words whose initial letters are capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
          </p>

          <h3>Definitions</h3>
          <p>For the purposes of this Privacy Policy:</p>
          <ul>
            <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
            <li><strong>Affiliate</strong> means an entity that controls, is controlled by, or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
            <li><strong>Application</strong> refers to Fundswala, the software program provided by the Company.</li>
            <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Fundswala, 2503, Tilak Chowk, Barshi. Solapur 413401.</li>
            <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
            <li><strong>Country</strong> refers to: Maharashtra, India</li>
            <li><strong>Device</strong> means any device that can access the Service such as a computer, a cell phone or a digital tablet.</li>
            <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
            <li><strong>Service</strong> refers to the Application or the Website or both.</li>
            <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company.</li>
            <li><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.</li>
            <li><strong>Website</strong> refers to Fundswala, accessible from{" "}
              <a href="https://www.fundswala.com/" target="_blank" rel="noopener noreferrer">
                https://www.fundswala.com/
              </a>
            </li>
            <li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
          </ul>

          <h2>Collecting and Using Your Personal Data</h2>
          <h3>Types of Data Collected</h3>

          <h4>Personal Data</h4>
          <p>
            While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
          </p>
          <ul>
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Address, State, Province, ZIP/Postal code, City</li>
            <li>Usage Data</li>
          </ul>

          <h4>Usage Data</h4>
          <p>
            Usage Data is collected automatically when using the Service. It may include information such as Your Device’s IP address, browser type and version, pages visited, time spent, and diagnostic data.
          </p>

          <h4>Tracking Technologies and Cookies</h4>
          <p>
            We use Cookies and similar tracking technologies to track activity on Our Service and store certain information. The technologies We use may include:
          </p>
          <ul>
            <li><strong>Cookies or Browser Cookies:</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or indicate when a Cookie is being sent. However, if You do not accept Cookies, some parts of our Service may not function properly.</li>
            <li><strong>Web Beacons:</strong> Certain sections of our Service and emails may contain small electronic files known as web beacons that allow Us to count users or collect related statistics.</li>
          </ul>
          <p>
            Cookies can be “Persistent” or “Session” Cookies. Persistent Cookies remain when You go offline, while Session Cookies are deleted when You close Your browser. Learn more about cookies on{" "}
            <a href="https://www.termsfeed.com/blog/cookies/#What_Are_Cookies" target="_blank" rel="noopener noreferrer">
              TermsFeed
            </a>.
          </p>

          <h3>Use of Your Personal Data</h3>
          <p>The Company may use Personal Data for the following purposes:</p>
          <ul>
            <li><strong>To provide and maintain our Service</strong>, including monitoring usage.</li>
            <li><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service.</li>
            <li><strong>For the performance of a contract:</strong> to fulfill purchase or service agreements.</li>
            <li><strong>To contact You:</strong> by email, calls, or notifications regarding updates or information.</li>
            <li><strong>To provide You</strong> with offers and information about similar goods and services.</li>
            <li><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</li>
            <li><strong>For business transfers:</strong> in case of merger, restructuring, or sale of assets.</li>
            <li><strong>For other purposes:</strong> such as analytics and service improvement.</li>
          </ul>

          <h3>Delete Your Personal Data</h3>
          <p>
            You can delete your account permanently by visiting{" "}
            <a href="https://www.fundswala.com/deleteaccount" target="_blank" rel="noopener noreferrer">
              https://www.fundswala.com/delete-account
            </a>.
          </p>

          <h2>Children’s Privacy</h2>
          <p>
            Our Service does not address anyone under 13. If you are a parent and believe your child has provided personal data, please contact us.
          </p>

          <h2>Links to Other Websites</h2>
          <p>
            Our Service may contain links to third-party sites. We advise reviewing their Privacy Policies, as We are not responsible for their practices.
          </p>

          <h2>Changes to this Privacy Policy</h2>
          <p>
            We may update Our Privacy Policy periodically. Changes are effective when posted on this page and the “Last updated” date is revised.
          </p>

          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, You can contact us:</p>
          <ul>
            <li>By email: <a href="mailto:vishal.kokate@fundswala.com">vishal.kokate@fundswala.com</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</>

    </>
  );
};

export default PrivacyPolicy;
